import './CloseButton.css';
import CloseImg from "../../assets/close.png";
import CloseLightImg from "../../assets/close-light.png";
import React from "react";

export default function CloseButton({ theme, onClick }) {
    const isDark = theme === "dark";
    return (
        <div className={`close-button${isDark ? ' white' : ''}`} onClick={onClick}>
            <img src={isDark ? CloseLightImg : CloseImg} className="close-button-icon" alt="Close" />
        </div>
    );
}
